import { useMemo } from 'react';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import P2GContentDropDown from '../../P2GContentDropDown';
import { BuyerNote, DeliveryInstructions, DeliverySafePlace } from '../../../lib/consts/ItemMetaConstants';
import { P2GText } from '@parcel2go/core-ui';
import { P2GBox } from '@parcel2go/core-ui';
import ItemTag from './ItemTag';

interface props {
  item: SmartSendItemApiModel;
  variant?: 'body2';
}

const include = [BuyerNote, DeliveryInstructions, DeliverySafePlace];

export default function ItemInstructions(props: props) {
  const notes = useMemo(() => {
    return include.filter((x) => {
      return !!props.item.Meta[x]?.Value;
    });
  }, [props.item.Meta, include]);

  if (notes.length === 0) {
    return null;
  }

  return (
    <P2GContentDropDown control={<ItemTag tag="Instructions" color="primary" />}>
      {notes.map((x) => (
        <P2GBox mt={1} mb={1} key={x}>
          <P2GText component="p" key={x} variant={props.variant}>
            <strong>{x}:</strong>
            <br />
            {props.item.Meta[x]?.Value}
          </P2GText>
        </P2GBox>
      ))}
    </P2GContentDropDown>
  );
}
